module.exports = __webpack_public_path__ + "static/project-16i-644b08dec0c2acd963d1be00730d1887.png";